import { apiSlice } from '../../../../app/apiSlice';
import configSiteUrls from '../../configs/configSiteUrls';
import { LicitacaoAnexo } from './types/LicitacaoAnexo';

const endpointUrl = configSiteUrls.SITE_LICITACAO_EP;
const endpointUrlPublic = configSiteUrls.SITE_LICITACAO_PUBLIC_EP;

function getLicitacaoAnexos({ idLicitacao }: { idLicitacao: string }) {
  if (!idLicitacao) {
    return {
      url: '',
      method: ''
    };
  }
  return {
    url: `${endpointUrlPublic}/anexos?idn=${idLicitacao}`,
    method: 'GET'
  };
}

function addAnexos(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/create`,
    method: 'POST',
    body: formData
  };
}

function addCapa(formData: FormData) {
  return {
    url: `${endpointUrl}/anexos/capa`,
    method: 'POST',
    body: formData
  };
}

function removeAnexosExcluidos(formData: FormData) {
  return {
    url: `${endpointUrl}/remover-anexos`,
    method: 'POST',
    body: formData
  };
}

export const licitacaoAnexoApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getLicitacaoAnexos: query<LicitacaoAnexo[], { idLicitacao: string }>({
      query: getLicitacaoAnexos,
      providesTags: ['LicitacaoAnexoSite']
    }),
    addLicitacaoAnexos: mutation<void, FormData>({
      query: addAnexos,
      invalidatesTags: ['LicitacaoAnexoSite']
    }),
    addLicitacaoCapa: mutation<void, FormData>({
      query: addCapa,
      invalidatesTags: ['LicitacaoAnexoSite']
    }),
    removeLicitacaoAnexoExcluido: mutation<void, FormData>({
      query: removeAnexosExcluidos,
      invalidatesTags: ['LicitacaoAnexoSite']
    })
  })
});
export const { 
  useGetLicitacaoAnexosQuery, 
  useAddLicitacaoAnexosMutation, 
  useRemoveLicitacaoAnexoExcluidoMutation, 
  useLazyGetLicitacaoAnexosQuery } = licitacaoAnexoApiSlice;
